export const onTitleChange = (page: string, title: any) => {
    return {
      type: 'onTitleChange',
      title: title,
      pageNumber: page
    }
}